import React from 'react';

import { Link, useLocation } from 'react-router-dom';

import { QueryResponse } from 'api/queries/prioritiesMatrixCards.query';

import CustomCard from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/customCard/customCard';
import { ProgramStatusSummaryReportQueryKeys } from 'components/Dashboards/Project/Components/VersionCompare/VersionCompare.consts';
import classes from 'components/widgets/PrioritiesMatrix/components/Cards/components/CardList/components/CardItem/CardItem.module.scss';

export const CardItem = ({ card }: { card: QueryResponse }) => {
    const { pathname, search } = useLocation();
    const linkTo = `${pathname}/card-${card.id}${card.isVirtual ? '-1' : ''}${search}`;
    return (
        <div className={classes.item}>
            <Link key={card.id} to={linkTo}>
                <CustomCard
                    {...card}
                    id={`${card.id}_${card.isVirtual}`}
                    showStatus={true}
                    taskId={card.id}
                    queryKeys={ProgramStatusSummaryReportQueryKeys}
                />
            </Link>
        </div>
    );
};
